import React from 'react';
import ProductTileWithVariations from './ProductTileWithVariations';
import PropTypes from 'prop-types';
import WithClickTracking from '../../components/WithClickTracking';
import { searchListName } from '../../Infrastructure/gtm';

const ProductTileWithVariationsWithClickTracking = WithClickTracking(ProductTileWithVariations);

const ProductTileWithVariationsContainer = ({
    results,
    onResultClick,
    addToCartEndPoint,
    wishlistData,
    toggleAddToListModal,
    loginPageUrl,
    isUserLoggedIn,
    isOrderRequestOnlyMarket
}) => {
    return (
        <div className="product-list__body">
            <div className="row">
                {results.map((product, i) => {
                    return (
                        <div className="col-12 mb-4" key={i}>
                            <ProductTileWithVariationsWithClickTracking
                                {...product}
                                onResultClick={onResultClick}
                                addToCartEndPoint={addToCartEndPoint}
                                listName={searchListName}
                                wishlistData={wishlistData}
                                toggleAddToListModal={toggleAddToListModal}
                                loginPageUrl={loginPageUrl}
                                isUserLoggedIn={isUserLoggedIn}
                                isOrderRequestOnlyMarket={isOrderRequestOnlyMarket}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

ProductTileWithVariationsContainer.propTypes = {
    results: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        Link: PropTypes.string,
        Image: PropTypes.shape({
            Url: PropTypes.string,
            Alt: PropTypes.string
        }),
        Description: PropTypes.string,
        Variations: PropTypes.arrayOf(PropTypes.shape())
    })),
    addToCartEndPoint: PropTypes.string,
    loginPageUrl: PropTypes.string,
    isUserLoggedIn: PropTypes.bool,
    isOrderRequestOnlyMarket: PropTypes.bool
};

export default ProductTileWithVariationsContainer;